module.exports = __webpack_public_path__ + "img/video.ccc90366.png";